import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        session: {
            user: '',
            name: '',
            companyCode: '',
            companyName: '',
        },
        loader: false
    },
    mutations: {
        setSession: function (state, value) {
            state.session.user = value.user;
            state.session.name = value.name;
            state.session.companyCode = value.companyCode;
            state.session.companyName = value.companyName
        },
        ChangeLoader: function (state, value) {
            state.loader = value;
        }
    },
    actions: {
    },
    modules: {
    }
})